const en = {
  // Navbar
  "navbar.por_que_ia": "Why AI",
  "navbar.servicios_agentes": "Services & AI Agents",
  "navbar.impacto_roi": "ROI Impact",
  "navbar.como_trabajamos": "How We Work",
  "navbar.diagnostico_roi": "ROI Diagnostic",
  "navbar.reservar_consulta": "Get My ROI Audit",

  // Hero
  "hero.badge": "AI Automation Agency · Impact-First",
  "hero.h1_part1": "Stop piloting AI. ",
  "hero.h1_gradient": "Start generating revenue",
  "hero.h1_part3": "",
  "hero.subtext": "At AIdeal Media, we design, train, and deploy custom AI agents and enterprise-grade workflows built to slash overhead and scale your bottom line.",
  "hero.cta": "Get My ROI Audit",

  // WhyAI
  "why.badge": "Why AI · Why Now",
  "why.h2_part1": "The advantage isn't having AI. It's ",
  "why.h2_gradient": "knowing how to turn it into revenue",
  "why.stats_part1": "",
  "why.stats_78": "78%",
  "why.stats_part2": " of companies are already piloting AI. Only ",
  "why.stats_12": "12%",
  "why.stats_part3": " capture ROI. The difference: strategy, deep process integration, and agents trained on your proprietary data.",
  "why.reason0_title": "Infinite scaling, zero new hires",
  "why.reason0_desc": "AI agents operating 24/7 across sales, support and marketing. Your human team focuses on strategic decisions, not repetitive tasks.",
  "why.reason1_title": "Data-driven decision making",
  "why.reason1_desc": "Intelligent dashboards and actionable predictions. Complete attribution. Know exactly which channel and agent fuels your growth.",
  "why.reason2_title": "Secure and audited deployment",
  "why.reason2_desc": "Native integrations with your stack (HubSpot, Shopify, Notion, Slack) with audit logs, access controls, and GDPR / SOC2 compliance.",
  "why.reason3_title": "ROI guaranteed in 90 days",
  "why.reason3_desc": "Within the first 90 days, we establish contract-backed targets and demonstrate, with full transparency, the results delivered and the real business impact on your company.",

  // Services
  "services.badge": "Services & AI Agents",
  "services.h2_part1": "Your dedicated ",
  "services.h2_gradient": "AI workforce",
  "services.description": "Each solution is deployed in 4–8 weeks and integrates with your current tools. With transparent metrics and a performance-based contract.",
  "services.item0_title": "AI Sales Agent",
  "services.item0_desc": "Automate your funnel: From lead qualification to booked meetings on autopilot.",
  "services.item0_feature0": "24/7 Multichannel",
  "services.item0_feature1": "CRM & HubSpot sync",
  "services.item0_feature2": "Voice + Text",
  "services.item0_metric": "+37% conversion",
  "services.item1_title": "Level 1 Support Agent",
  "services.item1_desc": "Resolves 68% of tickets without human intervention. Intelligent escalation to live agents when appropriate.",
  "services.item1_feature0": "Knowledge base RAG",
  "services.item1_feature1": "Zendesk / Intercom",
  "services.item1_feature2": "Multi-language",
  "services.item1_metric": "-52% response time",
  "services.item2_title": "Marketing Automation",
  "services.item2_desc": "End-to-end campaign execution. AI-driven creative, targeting, and optimization.",
  "services.item2_feature0": "Generative copy",
  "services.item2_feature1": "AI A/B testing",
  "services.item2_feature2": "Meta + Google Ads",
  "services.item2_metric": "3.1x ROAS",
  "services.item3_title": "Data & Business Intelligence",
  "services.item3_desc": "We unify your data on a single server and build predictive dashboards with actionable alerts.",
  "services.item3_feature0": "Supabase / BigQuery",
  "services.item3_feature1": "AI forecasting",
  "services.item3_feature2": "Slack alerts",
  "services.item3_metric": "100% visibility",
  "services.item4_title": "Custom AI Apps",
  "services.item4_desc": "We develop bespoke internal AI products: semantic search engines, copilots, enterprise workflows.",
  "services.item4_feature0": "RAG + Vector DB",
  "services.item4_feature1": "OpenAI / Anthropic",
  "services.item4_feature2": "Full ownership",
  "services.item4_metric": "6–8 week delivery",
  "services.item5_title": "Strategic AI Roadmap",
  "services.item5_desc": "We audit your existing workflows to pinpoint high-leverage use cases and design an execution plan centered on measurable ROI.",
  "services.item5_feature0": "ROI framework",
  "services.item5_feature1": "Change mgmt",
  "services.item5_feature2": "Clear KPIs",
  "services.item5_metric": "4-week roadmap",

  // RoiImpact
  "roi.badge": "ROI Impact",
  "roi.h2_part1": "Proven results.",
  "roi.h2_gradient": "Verifiable ROI",
  "roi.description": "Continuous measurement through shared dashboards with consolidated metrics from the last 12 months.",
  "roi.kpi0_label": "Average 90-day ROI",
  "roi.kpi0_delta": "+220%",
  "roi.kpi1_label": "Operational cost reduction",
  "roi.kpi1_delta": "vs baseline",
  "roi.kpi2_label": "Qualified leads / month",
  "roi.kpi2_delta": "+37% vs Q1",
  "roi.kpi3_label": "Support response time",
  "roi.kpi3_delta": "-52%",
  "roi.case0_industry": "eCommerce · Retail",
  "roi.case0_quote": "We slashed CAC by 34% and scaled our sales ops without a single new hire.",
  "roi.case0_author": "Marta Iglesias",
  "roi.case0_role": "Head of Growth, Vento Retail",
  "roi.case0_metric0_k": "+37%",
  "roi.case0_metric0_v": "Conversion",
  "roi.case0_metric1_k": "-34%",
  "roi.case0_metric1_v": "CAC",
  "roi.case0_metric2_k": "3.9x",
  "roi.case0_metric2_v": "ROI",
  "roi.case1_industry": "SaaS · B2B",
  "roi.case1_quote": "We automated 68% of our tickets, allowing our support team to stop firefighting and start driving strategy.",
  "roi.case1_author": "David Ruiz",
  "roi.case1_role": "COO, Metrikai",
  "roi.case1_metric0_k": "-52%",
  "roi.case1_metric0_v": "Response time",
  "roi.case1_metric1_k": "68%",
  "roi.case1_metric1_v": "Auto tickets",
  "roi.case1_metric2_k": "4.1x",
  "roi.case1_metric2_v": "ROI",
  "roi.case2_industry": "Real Estate · PropTech",
  "roi.case2_quote": "We replaced 3 separate tools with a single AI copilot for bookings, driving a 28% increase in direct revenue during our very first quarter of deployment.",
  "roi.case2_author": "Marcus Vance",
  "roi.case2_role": "Head of Operations, PropTech Group",
  "roi.case2_metric0_k": "+28%",
  "roi.case2_metric0_v": "Direct revenue",
  "roi.case2_metric1_k": "-3",
  "roi.case2_metric1_v": "Tools",
  "roi.case2_metric2_k": "3.4x",
  "roi.case2_metric2_v": "ROI",

  // Process
  "process.badge": "How We Work",
  "process.h2_part1": "From audit to ",
  "process.h2_gradient": "automation in 8 weeks",
  "process.h2_part3": "",
  "process.description": "A transparent, results-driven process built on measurable KPIs and performance-backed contracts.",
  "process.step0_title": "ROI Diagnostic",
  "process.step0_desc": "We identify your top 3 high-leverage AI opportunities and build your strategic roadmap.",
  "process.step0_duration": "1 week",
  "process.step1_title": "Design & Roadmap",
  "process.step1_desc": "We architect your AI infrastructure and set contract-backed KPIs to ensure total alignment with your business goals.",
  "process.step1_duration": "2 weeks",
  "process.step2_title": "Build & Training",
  "process.step2_desc": "We deploy custom agents and train them on your proprietary data for seamless integration into your existing stack.",
  "process.step2_duration": "4–6 weeks",
  "process.step3_title": "Continuous Optimization",
  "process.step3_desc": "Measure. Optimize. Dominate. Monthly impact reports ensure your AI workforce scales alongside your revenue.",
  "process.step3_duration": "Ongoing",

  // LeadForm
  "form.badge": "Personalized ROI Diagnostic",
  "form.h2_part1": "Get your personalized ",
  "form.h2_gradient": "AI opportunity report",
  "form.h2_part3": " in 24 hours",
  "form.description": "Tell us about your company and we'll send a custom diagnostic with the 3 highest-leverage AI use cases for your team.",
  "form.benefit0": "Prioritized use case report",
  "form.benefit1": "ROI estimate and cost per use case",
  "form.benefit2": "Suggested 90-day roadmap",
  "form.benefit3": "30-min session with an AI strategist",
  "form.talk_first": "PREFER TO SKIP THE FORM?",
  "form.talk_cta": "Talk to an AI Expert",
  "form.label_name": "Full name *",
  "form.placeholder_name": "Sarah Smith",
  "form.label_email": "Work email *",
  "form.placeholder_email": "sarah.smith@company.com",
  "form.label_company": "Company *",
  "form.placeholder_company": "Your company name",
  "form.label_website": "Website",
  "form.placeholder_website": "company.com",
  "form.label_industry": "Industry *",
  "form.placeholder_industry": "Select an industry",
  "form.label_budget": "Estimated monthly budget *",
  "form.placeholder_budget": "Select range",
  "form.label_goals": "Primary goals (select one or more)",
  "form.label_message": "Briefly describe your challenge (optional)",
  "form.placeholder_message": "e.g. We want to automate lead qualification on WhatsApp...",
  "form.max_chars": "Max. 500 characters",
  "form.privacy_text": "By submitting you accept our privacy policy. We never spam. Response within 24 business hours.",
  "form.submit_label": "Claim My ROI Audit",
  "form.submitting": "Sending...",
  "form.success_title": "Request received!",
  "form.success_desc": "We'll send your personalized ROI diagnostic within 24 hours. In the meantime, want to book your session with a strategist?",
  "form.success_cta": "Schedule now",
  "form.error_char_limit": "Message cannot exceed 500 characters.",
  "form.error_send": "We couldn't send your request. Please try again in a few minutes.",
  "form.error_network": "A network error occurred. Check your connection and try again.",
  "form.industry_0": "eCommerce / Retail",
  "form.industry_1": "SaaS / B2B",
  "form.industry_2": "Professional Services",
  "form.industry_3": "Hospitality / Tourism",
  "form.industry_4": "Health / Wellness",
  "form.industry_5": "Education",
  "form.industry_6": "Other",
  "form.budget_0": "Under €3,000",
  "form.budget_1": "€3,000 – €8,000",
  "form.budget_2": "€8,000 – €20,000",
  "form.budget_3": "Over €20,000",
  "form.goal_0": "Automate sales",
  "form.goal_1": "Automate support",
  "form.goal_2": "AI-powered marketing",
  "form.goal_3": "Data & BI",
  "form.goal_4": "Custom AI app",

  // FAQ
  "faq.badge": "FAQ",
  "faq.h2_part1": "Frequently asked",
  "faq.h2_gradient": "questions",
  "faq.q0": "What is the typical implementation timeline?",
  "faq.a0": "Most deployments are fully operational within 4 to 8 weeks. We provide a comprehensive, milestone-based roadmap from day one so you know exactly what to expect and when.",
  "faq.q1": "Do you work with companies of our size?",
  "faq.a1": "We specialize in high-growth companies and established mid-market enterprises. Our ideal partners are brands looking to scale operations and maximize efficiency without bloating their fixed overhead.",
  "faq.q2": "How do you handle data security and privacy?",
  "faq.a2": "Your data is your most valuable asset, and we treat it that way. We implement enterprise-grade encryption and strict privacy protocols. Your proprietary data is never used to train public AI models\u2014it stays 100% within your secure environment.",
  "faq.q3": "Is there a guarantee on ROI?",
  "faq.a3": "We are outcome-driven. Every partnership begins with contract-backed, measurable KPIs. We define exactly what success looks like and ensure our deployment hits those targets within the first 90 days.",
  "faq.q4": "What AI tech stack do you use?",
  "faq.a4": "We are tech-agnostic and leverage the industry\u2019s leading Large Language Models (LLMs) from providers like OpenAI, Anthropic, and Meta. Our priority is selecting the best-in-class model for your specific use case, integrating it seamlessly with your proprietary data to ensure peak performance.",
  "faq.q5": "Do we need to organize our data before we start?",
  "faq.a5": "Not at all \u2014 we handle the heavy lifting. Our initial diagnostic includes structuring and connecting your data streams, ensuring your AI agents have the clean, reliable information they need to perform at peak efficiency.",

  // CTA
  "cta.badge": "Ready to Scale?",
  "cta.h2_part1": "Launch your ",
  "cta.h2_gradient": "AI workforce",
  "cta.h2_part3": " this week",
  "cta.description": "Spend 30 minutes with a strategist to build your custom action plan and lock in your 90-day ROI estimate. No fluff\u2014just a clear path to automation.",
  "cta.button": "Get My ROI Roadmap",

  // Footer
  "footer.tagline": "AI Tools for Digital Business",
  "footer.description_line1": "We design AI agents and automation",
  "footer.description_line2": "with performance-based contracts",
  "footer.locations": "Operations: USA • European Union • LATAM",
  "footer.col_services": "SERVICES",
  "footer.col_navigation": "NAVIGATION",
  "footer.service_0": "AI Sales Agent",
  "footer.service_1": "Level 1 Support Agent",
  "footer.service_2": "Marketing Automation",
  "footer.service_3": "Data & Business Intelligence",
  "footer.service_4": "Custom AI Apps",
  "footer.service_5": "Strategic AI Roadmap",
  "footer.nav_why_ai": "Why AI",
  "footer.nav_roi_impact": "ROI Impact",
  "footer.nav_how_we_work": "How We Work",
  "footer.nav_faq": "FAQ",
  "footer.nav_roi_roadmap": "Get My ROI Roadmap",
  "footer.copyright": "© 2026 AIdeal Media. All Rights Reserved",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.cookies": "Cookies",

  // Shared Legal
  "legal.badge": "Legal Notice",
  "legal.back_to_home": "Back to Home",
  "legal.subtitle_privacy": "Effective Date: August 7, 2026 | Entity: AIDEAL LLC (Texas, USA)",
  "legal.subtitle_terms": "Effective Date: August 7, 2026 | Entity: AIDEAL LLC (Texas, USA)",
  "legal.subtitle_cookies": "Effective Date: August 7, 2026 | Entity: AIDEAL LLC (Texas, USA)",
  "legal.contact_title": "Legal Contact:",
  "legal.contact_entity": "AIDEAL LLC — Legal Department",
  "legal.contact_email": "Email: info@aidealmedia.info",
  "legal.contact_location": "Texas, United States",

  // Privacy Policy
  "privacy.title": "Privacy Policy",
  "privacy.s1_title": "1. Introduction",
  "privacy.s1_text": "AIDEAL LLC (\"we,\" \"our,\" or \"the Company\"), operating under the AIdeal Media brand, is committed to protecting the privacy of our users, clients, and visitors (\"You\"). This policy outlines how we handle personal data in compliance with the Texas Data Privacy and Security Act (TDPSA) and the EU General Data Protection Regulation (GDPR).",
  "privacy.s2_title": "2. Legal Basis for Processing (GDPR)",
  "privacy.s2_intro": "For users within the European Economic Area (EEA), we process your data under the following legal bases:",
  "privacy.s2_base0_title": "Performance of a Contract",
  "privacy.s2_base0_text": "To provide ROI Diagnostics and execute AI implementation services.",
  "privacy.s2_base1_title": "Consent",
  "privacy.s2_base1_text": "For sending marketing communications and using non-essential cookies.",
  "privacy.s2_base2_title": "Legitimate Interests",
  "privacy.s2_base2_text": "To ensure website security, improve our AI models, and conduct business analytics.",
  "privacy.s2_base3_title": "Legal Obligation",
  "privacy.s2_base3_text": "To comply with applicable tax and regulatory requirements.",
  "privacy.s3_title": "3. Data Collection and Purpose",
  "privacy.s3_text": "We collect identification data (name, email, phone), business operational data (budget, workflows), and technical browsing data (IP address, cookies). This information is used exclusively to deliver strategic AI roadmaps, manage service contracts, and ensure infrastructure security.",
  "privacy.s4_title": "4. International Data Transfers",
  "privacy.s4_text": "AIDEAL LLC is headquartered in Texas, USA. By using our services, you acknowledge that your personal data will be transferred to and processed in the United States. For EU users, we ensure a similar degree of protection by implementing Standard Contractual Clauses (SCCs) approved by the European Commission or relying on the EU-U.S. Data Privacy Framework where applicable.",
  "privacy.s5_title": "5. Your Rights (EEA & Texas)",
  "privacy.s5_intro": "Regardless of your location, you have the following rights regarding your data:",
  "privacy.s5_right0": "Right to Access: Request a copy of the data we hold about you.",
  "privacy.s5_right1": "Right to Rectification: Correct inaccurate or incomplete data.",
  "privacy.s5_right2": "Right to Erasure (\"Right to be Forgotten\"): Request the deletion of your data when it is no longer necessary.",
  "privacy.s5_right3": "Right to Restriction: Limit how we process your data in specific circumstances.",
  "privacy.s5_right4": "Right to Data Portability: Receive your data in a structured, machine-readable format.",
  "privacy.s5_right5": "Right to Object: Oppose processing based on legitimate interests or direct marketing.",
  "privacy.s5_right6": "Right to Opt-Out: Withdraw consent for marketing at any time.",
  "privacy.s5_contact": "To exercise these rights, contact: info@aidealmedia.info.",

  // Terms of Service
  "terms.title": "Terms of Service",
  "terms.s1_title": "1. Acceptance of Terms",
  "terms.s1_text": "By accessing this website or requesting an ROI Diagnostic, you agree to these Terms of Service and all applicable laws of the State of Texas and the United States.",
  "terms.s2_title": "2. Scope of Services",
  "terms.s2_text": "AIDEAL LLC provides AI consulting, agent development, and automation services. All preliminary projections, ROI estimates, and diagnostics provided through the website are informational only and do not constitute a binding guarantee of results until a formal Master Service Agreement (MSA) is signed.",
  "terms.s3_title": "3. Payment Terms",
  "terms.s3_text": "For international and EU clients, payments are due in U.S. Dollars (USD) unless otherwise agreed in writing. For recurring AI maintenance or SaaS-based agents, payments are typically processed via wire transfer or credit card on a Net 15 or Net 30 basis as specified in your individual statement of work.",
  "terms.s4_title": "4. Intellectual Property",
  "terms.s4_text": "AIDEAL LLC retains exclusive ownership of all proprietary methodologies, source code, and AI frameworks used to deliver our services. Clients are granted a limited, non-exclusive license to use the final deliverables solely for their internal business operations.",
  "terms.s5_title": "5. Limitation of Liability",
  "terms.s5_text": "To the maximum extent permitted by Texas law, AIDEAL LLC shall not be liable for indirect, incidental, or consequential damages (including loss of profits) resulting from the use of our website or preliminary AI estimations. Our total liability for any claim shall not exceed the amount paid by the client for the specific service in question.",
  "terms.s6_title": "6. Governing Law and Jurisdiction",
  "terms.s6_text": "These Terms are governed by the laws of the State of Texas, USA. Any disputes arising from these terms or our services shall be resolved exclusively in the state or federal courts located in Texas.",

  // Cookie Policy
  "cookies.title": "Cookie Policy",
  "cookies.s1_title": "1. What are Cookies?",
  "cookies.s1_text": "Cookies are small text files stored on your device that help us recognize you, optimize your experience, and analyze our performance.",
  "cookies.s2_title": "2. Categories of Cookies We Use",
  "cookies.s2_cat0_title": "Strictly Necessary",
  "cookies.s2_cat0_text": "Essential for the technical operation and security of our website. These cannot be switched off.",
  "cookies.s2_cat1_title": "Performance & Analytics",
  "cookies.s2_cat1_text": "These allow us to count visits and traffic sources (e.g., Google Analytics) to measure and improve our site performance.",
  "cookies.s2_cat2_title": "Functionality",
  "cookies.s2_cat2_text": "These enable the website to provide enhanced personalization based on your previous interactions.",
  "cookies.s2_cat3_title": "Marketing & Targeting",
  "cookies.s2_cat3_text": "Used to build a profile of your interests and show you relevant advertisements on other sites.",
  "cookies.s3_title": "3. Consent and Management",
  "cookies.s3_text": "Upon your first visit from the EU, a cookie banner will allow you to \"Accept All,\" \"Reject All,\" or \"Customize\" your preferences. You may also manage cookies through your browser settings (Chrome, Safari, Firefox, Edge). Note that disabling certain cookies may impact the functionality of our ROI Diagnostic tools.",

  // Cookie Consent Banner
  "cookieConsent.text": "We use first and third-party cookies to analyze site performance and deliver a personalized experience. Learn more in our Cookie Policy.",
  "cookieConsent.acceptAll": "Accept All",
  "cookieConsent.reject": "Reject",
  "cookieConsent.preferences": "Preferences",
  "cookieConsent.close": "Close cookie notice",
};

export default en;